import React from 'react'
import { node, bool, string } from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'
import { isText } from '@/utils'
import ProductLogo from './ProductLogo'

const logoWrapperCss = css`
  display: flex;
  align-items: center;
`

const labelWrapperCss = css`
  display: none;

  ${mediaQueries.xsmallScreen()} {
    display: flex;
    align-items: center;
  }
`

const dividerCss = (theme) => css`
  height: 28px;
  border-left: 1px solid ${theme.colors.gray500};
  margin: 0 16px;
`

const labelCss = css`
  margin-top: 2px;
`

const Logo = ({ logo = <ProductLogo />, label, hideDivider, className }) => {
  const displayDivider = isText || !hideDivider

  return (
    <div css={logoWrapperCss} className={className}>
      {logo}

      {label && (
        <div css={labelWrapperCss}>
          {displayDivider && <span css={dividerCss} />}
          <span css={labelCss}>{label}</span>
        </div>
      )}
    </div>
  )
}

Logo.propTypes = {
  logo: node,
  label: node,
  hideDivider: bool,
  className: string,
}

export default Logo
